import { defaultTheme } from "react-admin";
import { Theme } from "@mui/material";

const theme: Theme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: "#ff9900",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#231f20",
      contrastText: "#ffffff",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
};

export default theme;
